import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AdmGovernanceList from './AdmGovernanceList';
import AdmGovernanceSingle from './AdmGovernanceSingle';

export default () => <Switch>
	<Route path="/admin/governance" exact component={AdmGovernanceList} />
	<Route path="/admin/governance/create" component={AdmGovernanceSingle} />
	<Route path="/admin/governance/:id" component={AdmGovernanceSingle} />
</Switch>;
